import Vue from "vue";
import VueRouter from "vue-router";
import Axios from "axios";

import Login from "../views/Login";
import Dashboard from "../views/Dashboard";
import Register from "../views/Register";
import Admin from "../views/Admin";
import SubscriptionInactive from "../views/SubscriptionInactive";
import NewUser from "../views/NewUser";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
  },
  {
    path: "/inactive",
    name: "inactive",
    component: SubscriptionInactive,
  },
  {
    path: "/newuser",
    name: "newUser",
    component: NewUser
  },
  {
    path: "*",
    redirect: { name: "home" }
  }
];
const router = new VueRouter({
  routes,
});

export default router;
